import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { drywallServices } from "@/data/content";

const SPANS = [
  "md:col-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-1",
];

export const Services = () => {
  const { t } = useLanguage();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-ink py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid gap-8 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <Reveal>
              <SectionLabel text={t.services.label} testId="services-label" />
              <h2
                data-testid="services-heading"
                className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white md:text-6xl"
              >
                {t.services.heading}
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4">
            <Reveal delay={0.15}>
              <p className="text-base leading-relaxed text-neutral-400">
                {t.services.sub}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-14 grid gap-6 md:mt-20 md:grid-cols-3 md:gap-8">
          {drywallServices.map((s, i) => {
            const Icon = s.icon;
            const copy = t.services.items[s.slug];
            return (
              <Reveal key={s.slug} delay={(i % 3) * 0.1} className={SPANS[i]}>
                <div
                  data-testid={`service-card-${s.slug}`}
                  className="group relative flex h-full flex-col border border-white/10 bg-charcoal p-8 transition-transform duration-500 hover:-translate-y-2 md:p-10"
                >
                  <div className="flex items-start justify-between">
                    <Icon className="h-8 w-8 text-gold" strokeWidth={1.5} />
                    <span className="text-xs font-bold tracking-[0.2em] text-neutral-600">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-10 font-display text-2xl font-black uppercase leading-tight tracking-tight text-white md:mt-14 md:text-3xl">
                    {copy.title}
                  </h3>
                  <p className="mt-4 max-w-md text-sm leading-relaxed text-neutral-400 md:text-base">
                    {copy.text}
                  </p>
                  <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-gold transition-[width] duration-500 group-hover:w-full" />
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
